module.exports = __webpack_public_path__ + "static/cape-may-bird-3e0deaabda26bc9eead5a2a96f874ba0.jpeg";